// Permanent visual identity of the Stasher News rebrand. The Chakra Petch
// family is self-hosted in public/fonts/ and loaded by pages/_document.js.
export const DISPLAY_FONT = 'Chakra Petch'
